import axios, { AxiosInstance, AxiosRequestConfig, AxiosRequestHeaders, AxiosResponse } from 'axios';
import { readToken } from '@app/services/localStorage.service';
import { message } from 'antd';
import { navigateToLogin } from '@app/services/navigationService';

const BASE_URL = process.env.REACT_APP_BASE_URL ;

class HttpClient {
  private instance: AxiosInstance;

  constructor(config: AxiosRequestConfig = {}) {
    this.instance = axios.create({
      baseURL: `${BASE_URL}/api/v1`,
      timeout: 60000,
      ...config,
    });

    this.setupInterceptors();
  }

  private setupInterceptors() {
    // 请求拦截器
    this.instance.interceptors.request.use(
      (config) => {
        const token = readToken();
        if (token) {
          config.headers = { ...config.headers, Authorization: `Bearer ${token}` } as AxiosRequestHeaders;

        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );

    // 响应拦截器
    this.instance.interceptors.response.use(
      (response) => {
        // 处理200成功响应
        if (response.status === 200) {
          return response.data;
        }
        return response;
      },
      (error) => {
        const { response } = error;
        const errorMessage = response?.data?.message || error.message;

        // 根据不同状态码处理错误
        switch (response?.status) {
          case 400:
            // 请求参数错误
            console.error('请求参数错误:', errorMessage);
            break;
          case 401:
            // 未授权访问，清除token并重定向到登录页面
            localStorage.removeItem('token');
            navigateToLogin();
            break;
          case 403:
            // 权限不足
            console.error('权限不足:', errorMessage);
            break;
          case 404:
            // 资源不存在
            console.error('请求的资源不存在:', errorMessage);
            break;
          case 500:
            // 服务器内部错误
            console.error('服务器内部错误:', errorMessage);
            break;
          default:
            // 其他错误
            console.error('请求错误:', errorMessage);
        }
        if(response.data.message){
          message.error(response.data.message);
        }

        console.log('response',response)
        
        return Promise.reject({
         
          code: response?.data?.code || response?.status,
          data: response?.data?.data,
        });
      },
    );
  }

  public async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.instance.get(url, config);
  }

  public async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return this.instance.post(url, data, config);
  }

  public async put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return this.instance.put(url, data, config);
  }

  public async delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.instance.delete(url, config);
  }

  public async patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return this.instance.patch(url, data, config);
  }
}

export const httpClient = new HttpClient();